import { LottieOptions } from "lottie-react";
import loading_waalien from "../../assets/animations/loading_waalien.json" with { type: "json" };

export const REPORT_TO_SENTRY_AFTER_30_SECONDS = 30 * 1_000;

export const LOTTIE_LOADING_WAALIEN: LottieOptions = {
    loop: true,
    autoplay: true,
    animationData: loading_waalien,
    style: { height: "20rem" },
    renderer: "svg",
    rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
        progressiveLoad: false,
        hideOnTransparent: true,
    },
};

export const LOCK_SEND_SENTRY_MESSAGE_ON_LOADING_PAGE = "lock_send_sentry_message_on_loading_page";
